import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SimpleReward } from '../../../../../../types';

export interface RewardsConfigProps {
  simpleRewards: SimpleReward[];
}

const initialState: RewardsConfigProps = {
  simpleRewards: [],
};

export const rewardsSlice = createSlice({
  name: 'rewards',
  initialState,
  reducers: {
    setSimpleRewards: (state, action: PayloadAction<SimpleReward[]>) => {
      state.simpleRewards = action.payload;
    },
  },
});
